(function(){
  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    document.querySelectorAll('[data-fanworks-root]').forEach(init);
  });

  function init(root){
    var url = root.dataset.url || '';
    var key = root.dataset.key || '';
    if(!url || !key || !window.supabase) return;

    var sb = window.FanScoreSupabaseClient || window.supabase.createClient(url, key, { auth:{ persistSession:true, autoRefreshToken:true, detectSessionInUrl:false } });
    window.FanScoreSupabaseClient = sb;
    var session = null;
    var isAdmin = false;
    var creatorAthletes = [];
    var adminAthletes = [];
    var adminPartners = [];
    var partnerSchools = [];
    var selectedAthlete = null;
    var artworkReady = false;
    var mockupReady = false;
    var uploadBucket = 'fanworks-designs';
    var creatorSchools = [];

    function q(s){ return root.querySelector(s); }
    function qa(s){ return root.querySelectorAll(s); }
    function getStored(k){ try{return localStorage.getItem(k)||'';}catch(_e){return '';} }
    function setStored(k,v){ try{if(v)localStorage.setItem(k,String(v));}catch(_e){} }
    function pageContext(){ var p=new URLSearchParams(location.search||''); return { schoolId:p.get('school_id')||getStored('fanscore_school_id'), slug:p.get('team')||p.get('team_slug')||getStored('fanscore_team_slug') }; }
    function syncHomeLinks(){ var ctx=pageContext(); var home=root.dataset.homeUrl||'/pages/hall-of-fan'; var a=q('[data-fw-home-link]'); if(a)a.href=home; var gc=q('[data-fw-game-center-link]'); if(gc){var u=new URL('/pages/hall-of-fan-game-center',location.origin);if(ctx.schoolId)u.searchParams.set('school_id',ctx.schoolId);if(ctx.slug)u.searchParams.set('team',ctx.slug);u.searchParams.set('return_to',home);gc.href=u.pathname+u.search;} }
    var marketEmptyMarkup = q('[data-fw-market]') ? q('[data-fw-market]').innerHTML : '<div class="fw-empty">Approved FanWorks will appear here.</div>';
    function esc(v){
      return String(v == null ? '' : v).replace(/[&<>"']/g, function(c){
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
      });
    }
    function msg(el, text, ok){
      if(!el) return;
      el.textContent = text;
      el.style.background = ok ? 'rgba(31,157,85,.12)' : 'rgba(20,28,45,.06)';
    }
    function initials(a){
      return ((a.first_name || a.display_name || '?').charAt(0) + (a.last_name || '').charAt(0)).toUpperCase();
    }
    function athletePhoto(a){
      return a.headshot_url
        ? '<img class="fw-athlete-photo" src="'+esc(a.headshot_url)+'" alt="">'
        : '<div class="fw-athlete-photo fw-athlete-placeholder">'+esc(initials(a))+'</div>';
    }
    function meta(a){
      var bits = [];
      if(a.jersey_number) bits.push('#' + a.jersey_number);
      if(a.position) bits.push(a.position);
      if(a.class_year) bits.push(a.class_year);
      return bits.join(' · ');
    }
    function slugify(v){
      return String(v || 'file').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,80) || 'file';
    }
    function getFileExt(name, fallback){
      var parts = String(name || '').split('.');
      return parts.length > 1 ? parts.pop().toLowerCase() : fallback;
    }
    function loadImgFromFile(file){
      return new Promise(function(resolve, reject){
        var reader = new FileReader();
        reader.onload = function(e){
          var img = new Image();
          img.onload = function(){ resolve(img); };
          img.onerror = function(){ reject(new Error('Could not read image file.')); };
          img.src = e.target.result;
        };
        reader.onerror = function(){ reject(new Error('Could not read image file.')); };
        reader.readAsDataURL(file);
      });
    }
    function imageHasTransparency(img){
      var max = 512;
      var scale = Math.min(1, max / Math.max(img.width, img.height));
      var w = Math.max(1, Math.round(img.width * scale));
      var h = Math.max(1, Math.round(img.height * scale));
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var data = ctx.getImageData(0, 0, w, h).data;
      for(var i = 3; i < data.length; i += 4){
        if(data[i] < 250) return true;
      }
      return false;
    }
    async function validateArtworkFile(file){
      if(!file) throw new Error('Upload the print-ready artwork PNG.');
      if(!(file.type === 'image/png' || /\.png$/i.test(file.name || ''))){
        throw new Error('Print-ready artwork must be a PNG file.');
      }
      var img = await loadImgFromFile(file);
      if(!(img.width === 3300 && img.height === 4200)){
        throw new Error('Print-ready artwork must be exactly 3300 × 4200 px (11×14 in at 300 DPI).');
      }
      if(!imageHasTransparency(img)){
        throw new Error('Print-ready artwork must include transparency. Please upload a transparent-background PNG.');
      }
      return true;
    }
    async function validateMockupFile(file){
      if(!file) throw new Error('Upload a shirt mockup image.');
      var valid = ['image/png','image/jpeg','image/webp'];
      if(valid.indexOf(file.type) === -1 && !/\.(png|jpe?g|webp)$/i.test(file.name || '')){
        throw new Error('Mockup must be a PNG, JPG, or WEBP image.');
      }
      var img = await loadImgFromFile(file);
      if(img.width < 600 || img.height < 600){
        throw new Error('Mockup image is too small. Please upload a clearer shirt mockup.');
      }
      return true;
    }

    function setUploadStatus(kind, text, state){
      var el = q('[data-fw-'+kind+'-status]');
      var card = q('[data-fw-'+kind+'-card]');
      if(el){
        el.textContent = text;
        el.classList.toggle('is-good', state === 'good');
        el.classList.toggle('is-bad', state === 'bad');
      }
      if(card){
        card.classList.toggle('is-good', state === 'good');
        card.classList.toggle('is-bad', state === 'bad');
      }
    }
    function setUploadPreview(kind, file){
      var holder = q('[data-fw-'+kind+'-preview]');
      if(!holder) return;
      holder.innerHTML = '';
      if(!file){
        holder.hidden = true;
        return;
      }
      var img = document.createElement('img');
      img.alt = kind === 'artwork' ? 'Artwork preview' : 'Shirt mockup preview';
      var objectUrl = URL.createObjectURL(file);
      img.onload = function(){ URL.revokeObjectURL(objectUrl); };
      img.src = objectUrl;
      holder.appendChild(img);
      holder.hidden = false;
    }
    function updateSubmitReady(){
      var submit = q('[data-fw-submit-design]');
      if(!submit) return;
      submit.disabled = !(artworkReady && mockupReady);
    }
    function resetUploads(){
      artworkReady = false;
      mockupReady = false;
      var art = q('[data-fw-artwork-file]');
      var mock = q('[data-fw-mockup-file]');
      if(art) art.value = '';
      if(mock) mock.value = '';
      setUploadStatus('artwork', 'NO FILE SELECTED', 'neutral');
      setUploadStatus('mockup', 'NO FILE SELECTED', 'neutral');
      setUploadPreview('artwork', null);
      setUploadPreview('mockup', null);
      updateSubmitReady();
    }
    async function preflightArtwork(){
      var input = q('[data-fw-artwork-file]');
      var file = input && input.files ? input.files[0] : null;
      artworkReady = false;
      updateSubmitReady();
      if(!file){
        setUploadStatus('artwork', 'NO FILE SELECTED', 'neutral');
        setUploadPreview('artwork', null);
        return;
      }
      setUploadStatus('artwork', 'CHECKING '+file.name+'…', 'neutral');
      setUploadPreview('artwork', file);
      try{
        await validateArtworkFile(file);
        artworkReady = true;
        setUploadStatus('artwork', 'READY ✓  '+file.name, 'good');
      }catch(err){
        artworkReady = false;
        setUploadStatus('artwork', (err && err.message) ? err.message : 'Artwork is not print ready.', 'bad');
      }
      updateSubmitReady();
    }
    async function preflightMockup(){
      var input = q('[data-fw-mockup-file]');
      var file = input && input.files ? input.files[0] : null;
      mockupReady = false;
      updateSubmitReady();
      if(!file){
        setUploadStatus('mockup', 'NO FILE SELECTED', 'neutral');
        setUploadPreview('mockup', null);
        return;
      }
      setUploadStatus('mockup', 'CHECKING '+file.name+'…', 'neutral');
      setUploadPreview('mockup', file);
      try{
        await validateMockupFile(file);
        mockupReady = true;
        setUploadStatus('mockup', 'READY ✓  '+file.name, 'good');
      }catch(err){
        mockupReady = false;
        setUploadStatus('mockup', (err && err.message) ? err.message : 'Mockup is not valid.', 'bad');
      }
      updateSubmitReady();
    }
    async function ensureCreatorId(){
      var existing = await sb.from('fw_creators').select('id').eq('user_id', session.user.id).maybeSingle();
      if(existing.error) throw existing.error;
      if(existing.data && existing.data.id) return existing.data.id;
      var created = await sb.from('fw_creators')
        .insert({ user_id: session.user.id, display_name: (session.user.email || 'creator').split('@')[0] })
        .select('id')
        .single();
      if(created.error) throw created.error;
      return created.data.id;
    }
    async function uploadDesignFile(file, kind){
      var ext = getFileExt(file.name, kind === 'artwork' ? 'png' : 'jpg');
      var school = slugify(selectedAthlete && selectedAthlete.school_slug);
      var athlete = slugify(selectedAthlete && selectedAthlete.display_name);
      var stamp = Date.now();
      var path = [String(session.user.id), school, athlete, stamp + '-' + kind + '.' + ext].join('/');
      var uploaded = await sb.storage.from(uploadBucket).upload(path, file, {
        cacheControl: '3600',
        upsert: false,
        contentType: file.type || undefined
      });
      if(uploaded.error) throw uploaded.error;
      var publicData = sb.storage.from(uploadBucket).getPublicUrl(path);
      return publicData && publicData.data ? publicData.data.publicUrl : null;
    }

    qa('.fw-tab[data-view]').forEach(function(tab){
      tab.addEventListener('click', function(){
        var v = tab.dataset.view;
        qa('.fw-tab[data-view]').forEach(function(x){ x.classList.toggle('is-active', x === tab); });
        qa('.fw-view').forEach(function(p){ p.classList.toggle('is-active', p.dataset.viewPanel === v); });
        if(v === 'printer') loadJobs();
        if(v === 'admin' && isAdmin) loadAllAdmin();
      });
    });

    function loadCreatorSchools(){
      sb.from('fw_creator_schools')
        .select('school_id,school_slug,school_name,school_short_name,enabled_athletes,primary_color')
        .order('school_name')
        .then(function(r){
          var sel = q('[data-fw-school]');
          var headerSel = q('[data-fw-header-team]');
          if(!sel) return;
          if(r.error){
            sel.innerHTML = '<option value="">Unable to load schools</option>';
            if(headerSel) headerSel.innerHTML = '<option value="">Teams unavailable</option>';
            return;
          }
          creatorSchools = r.data || [];
          var h = '<option value="">Choose a school</option>';
          var headerHtml = '<option value="">Choose team</option>';
          creatorSchools.forEach(function(s){
            h += '<option value="'+esc(s.school_slug)+'">'+esc(s.school_name)+' ('+Number(s.enabled_athletes || 0)+')</option>';
            headerHtml += '<option value="'+esc(s.school_slug)+'">'+esc(s.school_name)+'</option>';
          });
          sel.innerHTML = h;
          if(headerSel) headerSel.innerHTML = headerHtml;
          var ctx=pageContext();
          var selected=creatorSchools.find(function(x){return ctx.schoolId && x.school_id===ctx.schoolId;}) || creatorSchools.find(function(x){return ctx.slug && x.school_slug===ctx.slug;});
          if(selected){sel.value=selected.school_slug;if(headerSel)headerSel.value=selected.school_slug;loadCreatorAthletes(selected.school_slug);} else if(ctx.slug){ q('[data-fw-athlete-list]').innerHTML='<div class="fw-empty">Your selected team does not yet have FanWorks-enabled athletes.</div>'; }
        });
    }

    function loadCreatorAthletes(slug){
      creatorAthletes = [];
      selectedAthlete = null;
      q('[data-fw-selected-athlete]').hidden = true;
      q('[data-fw-design-fields]').hidden = true;
      var search = q('[data-fw-athlete-search]');
      var holder = q('[data-fw-athlete-list]');
      if(!slug){
        search.disabled = true;
        holder.innerHTML = '<div class="fw-empty">Choose a school to see its FanWorks athletes.</div>';
        return;
      }
      search.disabled = false;
      holder.innerHTML = '<div class="fw-empty">Loading athletes...</div>';
      sb.from('fw_athlete_catalog')
        .select('source_athlete_id,fanworks_athlete_id,school_slug,school_name,display_name,first_name,last_name,jersey_number,position,class_year,headshot_url,fanworks_enabled,allow_fan_designs')
        .eq('school_slug', slug)
        .eq('fanworks_enabled', true)
        .eq('allow_fan_designs', true)
        .order('display_name')
        .then(function(r){
          if(r.error){
            holder.innerHTML = '<div class="fw-empty">Unable to load athletes.</div>';
            return;
          }
          creatorAthletes = r.data || [];
          renderCreatorAthletes();
        });
    }

    function renderCreatorAthletes(){
      var term = (q('[data-fw-athlete-search]').value || '').trim().toLowerCase();
      var holder = q('[data-fw-athlete-list]');
      var list = creatorAthletes.filter(function(a){
        return !term || [a.display_name, a.jersey_number, a.position].join(' ').toLowerCase().indexOf(term) > -1;
      });
      if(!list.length){
        holder.innerHTML = '<div class="fw-empty">No matching athletes.</div>';
        return;
      }
      holder.innerHTML = list.map(function(a){
        return '<article class="fw-athlete-card">'+
          athletePhoto(a)+
          '<div class="fw-athlete-info"><h3>'+esc(a.display_name)+'</h3><p>'+esc(a.school_name)+'<br>'+esc(meta(a))+'</p></div>'+
          '<button class="fw-pick" type="button" data-fw-pick="'+esc(a.source_athlete_id)+'">Create for this player</button>'+
        '</article>';
      }).join('');
      holder.querySelectorAll('[data-fw-pick]').forEach(function(b){
        b.addEventListener('click', function(){
          selectedAthlete = creatorAthletes.find(function(a){ return a.source_athlete_id === b.dataset.fwPick; });
          if(!selectedAthlete) return;
          var box = q('[data-fw-selected-athlete]');
          box.innerHTML = esc(selectedAthlete.display_name)+'<small>'+esc(selectedAthlete.school_name)+' · '+esc(meta(selectedAthlete))+'</small>';
          box.hidden = false;
          q('[data-fw-design-fields]').hidden = false;
          q('[data-fw-create-result]').textContent = '';
          resetUploads();
          box.scrollIntoView({ behavior:'smooth', block:'center' });
        });
      });
    }

    async function chooseSchool(slug){
      q('[data-fw-athlete-search]').value = '';
      var row=creatorSchools.find(function(x){return x.school_slug===slug;});
      var creatorSel=q('[data-fw-school]'),headerSel=q('[data-fw-header-team]');
      if(creatorSel&&creatorSel.value!==slug)creatorSel.value=slug;
      if(headerSel&&headerSel.value!==slug)headerSel.value=slug;
      if(row){
        setStored('fanscore_school_id',row.school_id);setStored('fanscore_team_slug',row.school_slug);setStored('nil_arcade_team_slug',row.school_slug);
        if(session){var pr=await sb.from('fs_profiles').update({school_id:row.school_id}).eq('id',session.user.id);if(pr.error)msg(q('[data-fw-create-result]'),'Team selected here, but FanScore profile sync failed: '+pr.error.message,false);}
        try{window.dispatchEvent(new CustomEvent('fanscore:team-change',{detail:{schoolId:row.school_id,schoolSlug:row.school_slug,teamSlug:row.school_slug,schoolName:row.school_name,teamName:row.school_name,primary:row.primary_color||undefined,primary_color:row.primary_color||undefined}}));}catch(_e){}
        syncHomeLinks();
      }
      loadCreatorAthletes(slug);
    }
    q('[data-fw-school]').addEventListener('change', function(){chooseSchool(this.value);});
    var headerTeam=q('[data-fw-header-team]');if(headerTeam)headerTeam.addEventListener('change',function(){chooseSchool(this.value);});
    q('[data-fw-athlete-search]').addEventListener('input', renderCreatorAthletes);

    q('[data-fw-choose-artwork]').addEventListener('click', function(){
      q('[data-fw-artwork-file]').click();
    });
    q('[data-fw-choose-mockup]').addEventListener('click', function(){
      q('[data-fw-mockup-file]').click();
    });
    q('[data-fw-artwork-file]').addEventListener('change', preflightArtwork);
    q('[data-fw-mockup-file]').addEventListener('change', preflightMockup);

    function checkAdmin(){
      if(!session){
        isAdmin = false;
        q('[data-fw-admin-tab]').hidden = true;
        return Promise.resolve(false);
      }
      return Promise.all([
        sb.from('fs_admins').select('user_id').eq('user_id', session.user.id).maybeSingle(),
        sb.from('admin_users').select('user_id').eq('user_id', session.user.id).maybeSingle()
      ]).then(function(rs){
        isAdmin = !!(rs[0].data || rs[1].data);
        q('[data-fw-admin-tab]').hidden = !isAdmin;
        if(isAdmin){
          loadAdminSchools();
          loadPartnerSchools();
          loadAdminApprovals();
          loadAdminPartners();
        }
        return isAdmin;
      });
    }

    function loadAdminSchools(){
      sb.from('fs_schools').select('slug,name').eq('active', true).order('name').then(function(r){
        var sel = q('[data-fw-admin-school]');
        if(!sel || r.error) return;
        var current = sel.value;
        var h = '<option value="">Choose a school</option>';
        (r.data || []).forEach(function(s){ h += '<option value="'+esc(s.slug)+'">'+esc(s.name)+'</option>'; });
        sel.innerHTML = h;
        if(current) sel.value = current;
      });
    }

    function loadAdminAthletes(){
      if(!isAdmin) return;
      var slug = q('[data-fw-admin-school]').value;
      var holder = q('[data-fw-admin-list]');
      if(!slug){
        holder.innerHTML = '<div class="fw-empty">Choose a school.</div>';
        return;
      }
      holder.innerHTML = '<div class="fw-empty">Loading master roster...</div>';
      sb.from('fw_athlete_catalog').select('*').eq('school_slug', slug).order('display_name').then(function(r){
        if(r.error){
          holder.innerHTML = '<div class="fw-empty">'+esc(r.error.message)+'</div>';
          return;
        }
        adminAthletes = r.data || [];
        renderAdminAthletes();
      });
    }

    function renderAdminAthletes(){
      var term = (q('[data-fw-admin-search]').value || '').trim().toLowerCase();
      var holder = q('[data-fw-admin-list]');
      var list = adminAthletes.filter(function(a){
        return !term || [a.display_name, a.jersey_number, a.position].join(' ').toLowerCase().indexOf(term) > -1;
      });
      if(!list.length){
        holder.innerHTML = '<div class="fw-empty">No matching athletes.</div>';
        return;
      }
      holder.innerHTML = list.map(function(a){
        var enabled = !!a.fanworks_enabled;
        var share = (Number(a.athlete_share_bps || 4000) / 100).toFixed(0);
        return '<article class="fw-athlete-card fw-admin-card" data-admin-athlete="'+esc(a.source_athlete_id)+'">'+
          athletePhoto(a)+
          '<div class="fw-athlete-info"><h3>'+esc(a.display_name)+'</h3><p>'+esc(meta(a))+' · '+(enabled ? 'FanWorks active' : 'Not enabled')+'</p></div>'+
          '<div class="fw-admin-controls">'+
            '<label>Athlete share %<input data-share type="number" min="0" max="100" step="1" value="'+esc(share)+'"></label>'+
            '<label class="fw-switch"><input data-approval type="checkbox" '+(a.approval_required ? 'checked' : '')+'> Approval required</label>'+
            '<label class="fw-switch"><input data-designs type="checkbox" '+(a.allow_fan_designs ? 'checked' : '')+'> Fan designs allowed</label>'+
          '</div>'+
          '<div class="fw-admin-actions">'+
            '<button type="button" data-fw-save>'+(enabled ? 'Save settings' : 'Enable FanWorks')+'</button>'+
            (enabled ? '<button type="button" data-fw-disable class="is-disable">Disable</button>' : '')+
          '</div>'+
        '</article>';
      }).join('');
      holder.querySelectorAll('[data-fw-save]').forEach(function(btn){
        btn.addEventListener('click', function(){ saveAdminAthlete(btn, true); });
      });
      holder.querySelectorAll('[data-fw-disable]').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(window.confirm('Disable FanWorks for this athlete?')) saveAdminAthlete(btn, false);
        });
      });
    }

    function saveAdminAthlete(btn, enabled){
      var card = btn.closest('[data-admin-athlete]');
      var id = card.dataset.adminAthlete;
      var a = adminAthletes.find(function(x){ return x.source_athlete_id === id; });
      var share = Math.round(Number(card.querySelector('[data-share]').value || 40) * 100);
      btn.disabled = true;
      sb.rpc('fw_admin_set_athlete', {
        p_source_athlete_id: id,
        p_enabled: enabled,
        p_share_bps: share,
        p_approval_required: card.querySelector('[data-approval]').checked,
        p_allow_fan_designs: card.querySelector('[data-designs]').checked
      }).then(function(r){
        btn.disabled = false;
        if(r.error){
          msg(q('[data-fw-admin-result]'), r.error.message, false);
          return;
        }
        msg(q('[data-fw-admin-result]'), a.display_name + (enabled ? ' is now available in FanWorks.' : ' has been disabled in FanWorks.'), true);
        loadAdminAthletes();
        loadCreatorSchools();
      });
    }

    function loadAdminApprovals(){
      if(!isAdmin) return Promise.resolve();
      var holder=q('[data-fw-admin-approvals]');
      if(holder) holder.innerHTML='<div class="fw-empty">Loading artwork approvals...</div>';
      return sb.rpc('fw_admin_approval_queue').then(function(r){
        if(r.error){
          if(holder) holder.innerHTML='<div class="fw-empty">'+esc(r.error.message)+'</div>';
          return;
        }
        var payload=r.data||{};
        var items=Array.isArray(payload.items)?payload.items:[];
        var count=q('[data-fw-admin-pending-count]');
        if(count) count.textContent=String(Number(payload.pending_count||items.length));
        if(!holder) return;
        if(!items.length){holder.innerHTML='<div class="fw-empty">No designs are waiting for admin review.</div>';return;}
        holder.innerHTML=items.map(function(d){
          return '<article class="fw-job" data-fw-review-design="'+esc(d.design_id)+'">'+
            '<div class="fw-job-main">'+(d.mockup_url?'<img class="fw-job-img" src="'+esc(d.mockup_url)+'" alt="Design mockup">':'')+
              '<div><h3>'+esc(d.title||'FanWork')+'</h3><div class="fw-job-meta">'+esc(d.school_name||'')+' · '+esc(d.athlete_name||'')+'<br>Creator: '+esc(d.creator_name||'Fan creator')+'</div>'+
              '<div class="fw-action-row">'+(d.artwork_url?'<a class="fw-link" href="'+esc(d.artwork_url)+'" target="_blank" rel="noopener">VIEW PRINT ART</a>':'')+(d.mockup_url?'<a class="fw-link" href="'+esc(d.mockup_url)+'" target="_blank" rel="noopener">VIEW MOCKUP</a>':'')+'</div></div></div>'+
            '<label>Admin note<textarea data-fw-review-note placeholder="Required when requesting changes or rejecting"></textarea></label>'+
            '<div class="fw-action-row"><button type="button" data-fw-review-action="approve" class="fw-primary">APPROVE</button><button type="button" data-fw-review-action="changes_requested" class="fw-secondary">REQUEST CHANGES</button><button type="button" data-fw-review-action="reject" class="fw-secondary">REJECT</button></div>'+
          '</article>';
        }).join('');
        holder.querySelectorAll('[data-fw-review-action]').forEach(function(btn){
          btn.addEventListener('click',function(){ reviewAdminDesign(btn,btn.dataset.fwReviewAction); });
        });
      });
    }

    function reviewAdminDesign(btn,action){
      var card=btn.closest('[data-fw-review-design]');
      if(!card)return;
      var note=(card.querySelector('[data-fw-review-note]').value||'').trim();
      if((action==='changes_requested'||action==='reject')&&!note){
        msg(q('[data-fw-admin-approval-result]'),'Add a note before requesting changes or rejecting a design.',false);return;
      }
      card.querySelectorAll('button').forEach(function(x){x.disabled=true;});
      sb.rpc('fw_admin_review_design',{p_design_id:card.dataset.fwReviewDesign,p_action:action,p_note:note||null}).then(function(r){
        if(r.error){msg(q('[data-fw-admin-approval-result]'),r.error.message,false);card.querySelectorAll('button').forEach(function(x){x.disabled=false;});return;}
        msg(q('[data-fw-admin-approval-result]'),'Design review saved.',true);
        loadAdminApprovals();
        loadMarket();
      });
    }

    function loadPartnerSchools(){
      if(!isAdmin)return Promise.resolve();
      return sb.from('fs_schools').select('id,slug,name,subdivision').eq('active',true).in('subdivision',['FBS','FCS']).order('name').then(function(r){
        if(r.error)return;
        partnerSchools=r.data||[];
        var ctx=pageContext();
        var selects=[q('[data-fw-partner-school]'),q('[data-fw-partner-filter-school]')];
        selects.forEach(function(sel,index){
          if(!sel)return;
          var current=sel.value;
          var h=index===0?'<option value="">Choose a school</option>':'<option value="">All schools</option>';
          partnerSchools.forEach(function(s){h+='<option value="'+esc(s.slug)+'">'+esc(s.name)+'</option>';});
          sel.innerHTML=h;
          if(current)sel.value=current;
          else if(index===0&&ctx.slug&&partnerSchools.some(function(x){return x.slug===ctx.slug;}))sel.value=ctx.slug;
        });
      });
    }

    function loadAdminPartners(){
      if(!isAdmin)return Promise.resolve();
      var holder=q('[data-fw-partner-list]');
      if(holder)holder.innerHTML='<div class="fw-empty">Loading local production partners...</div>';
      var filter=q('[data-fw-partner-filter-school]');
      return sb.rpc('fw_admin_local_partners',{p_school_slug:filter&&filter.value?filter.value:null}).then(function(r){
        if(r.error){if(holder)holder.innerHTML='<div class="fw-empty">'+esc(r.error.message)+'</div>';return;}
        adminPartners=r.data||[];
        if(!holder)return;
        if(!adminPartners.length){holder.innerHTML='<div class="fw-empty">No local production partners are configured for this selection.</div>';return;}
        holder.innerHTML=adminPartners.map(function(p){
          return '<article class="fw-job" data-fw-partner-row="'+esc(p.partner_id)+'">'+
            '<div class="fw-job-head"><span class="fw-badge">'+esc(p.status||'')+'</span><span class="fw-badge">priority '+esc(p.priority||'')+'</span></div>'+
            '<div class="fw-job-main"><div><h3>'+esc(p.business_name||'Local partner')+'</h3><div class="fw-job-meta">'+esc(p.school_slug||'')+' · '+esc([p.city,p.region].filter(Boolean).join(', '))+'<br>Capacity '+esc(p.current_load||0)+' / '+esc(p.daily_capacity||0)+' · SLA '+esc(p.acceptance_sla_minutes||0)+' min · Score '+esc(p.fulfillment_score||0)+'<br>Account: '+esc(p.linked_user_email||'not linked')+'</div></div></div>'+
            '<div class="fw-action-row"><button type="button" data-fw-edit-partner="'+esc(p.partner_id)+'" class="fw-secondary">EDIT</button></div>'+
          '</article>';
        }).join('');
        holder.querySelectorAll('[data-fw-edit-partner]').forEach(function(btn){btn.addEventListener('click',function(){fillPartnerForm(btn.dataset.fwEditPartner);});});
      });
    }

    function partnerField(name){return q('[data-fw-partner-'+name+']');}
    function resetPartnerForm(){
      var form=q('[data-fw-partner-form]');if(form)form.reset();
      if(partnerField('id'))partnerField('id').value='';
      if(partnerField('priority'))partnerField('priority').value='1';
      if(partnerField('capacity'))partnerField('capacity').value='50';
      if(partnerField('sla'))partnerField('sla').value='60';
      if(partnerField('score'))partnerField('score').value='100';
      if(partnerField('pickup'))partnerField('pickup').checked=true;
      if(partnerField('shipping'))partnerField('shipping').checked=true;
      var ctx=pageContext();if(partnerField('school')&&ctx.slug)partnerField('school').value=ctx.slug;
      msg(q('[data-fw-partner-result]'),'Ready for a new local production partner.',true);
    }
    function fillPartnerForm(id){
      var p=adminPartners.find(function(x){return x.partner_id===id;});if(!p)return;
      partnerField('id').value=p.partner_id||'';
      partnerField('business').value=p.business_name||'';
      partnerField('school').value=p.school_slug||'';
      partnerField('account-email').value=p.linked_user_email||'';
      partnerField('contact-name').value=p.contact_name||'';
      partnerField('contact-email').value=p.contact_email||'';
      partnerField('contact-phone').value=p.contact_phone||'';
      partnerField('city').value=p.city||'';
      partnerField('region').value=p.region||'';
      partnerField('postal').value=p.postal_code||'';
      partnerField('status').value=p.status||'active';
      partnerField('priority').value=p.priority||1;
      partnerField('capacity').value=p.daily_capacity||0;
      partnerField('sla').value=p.acceptance_sla_minutes||60;
      partnerField('score').value=p.fulfillment_score==null?100:p.fulfillment_score;
      partnerField('pickup').checked=!!p.pickup_enabled;
      partnerField('shipping').checked=!!p.shipping_enabled;
      q('[data-fw-partner-form]').scrollIntoView({behavior:'smooth',block:'start'});
    }
    function saveLocalPartner(ev){
      ev.preventDefault();
      var business=(partnerField('business').value||'').trim();
      var school=(partnerField('school').value||'').trim();
      if(!business||!school){msg(q('[data-fw-partner-result]'),'Business name and school are required.',false);return;}
      var payload={
        p_partner_id:partnerField('id').value||null,
        p_business_name:business,
        p_contact_name:(partnerField('contact-name').value||'').trim()||null,
        p_contact_email:(partnerField('contact-email').value||'').trim()||null,
        p_contact_phone:(partnerField('contact-phone').value||'').trim()||null,
        p_city:(partnerField('city').value||'').trim()||null,
        p_region:(partnerField('region').value||'').trim()||null,
        p_postal_code:(partnerField('postal').value||'').trim()||null,
        p_status:partnerField('status').value||'active',
        p_pickup_enabled:partnerField('pickup').checked,
        p_shipping_enabled:partnerField('shipping').checked,
        p_daily_capacity:Number(partnerField('capacity').value||0),
        p_acceptance_sla_minutes:Number(partnerField('sla').value||60),
        p_fulfillment_score:Number(partnerField('score').value||100),
        p_school_slug:school,
        p_priority:Number(partnerField('priority').value||1),
        p_partner_user_email:(partnerField('account-email').value||'').trim()||null
      };
      msg(q('[data-fw-partner-result]'),'Saving local production partner...',false);
      sb.rpc('fw_admin_save_local_partner',payload).then(function(r){
        if(r.error){msg(q('[data-fw-partner-result]'),r.error.message,false);return;}
        msg(q('[data-fw-partner-result]'),'Local production partner saved and school routing is active.',true);
        partnerField('id').value=String(r.data||payload.p_partner_id||'');
        loadAdminPartners();
      });
    }

    function loadAllAdmin(){
      if(!isAdmin)return;
      loadAdminAthletes();
      loadAdminApprovals();
      loadPartnerSchools();
      loadAdminPartners();
    }

    q('[data-fw-admin-school]').addEventListener('change', loadAdminAthletes);
    q('[data-fw-admin-search]').addEventListener('input', renderAdminAthletes);
    q('[data-fw-admin-refresh]').addEventListener('click', loadAllAdmin);
    q('[data-fw-partner-filter-school]').addEventListener('change', loadAdminPartners);
    q('[data-fw-partner-form]').addEventListener('submit', saveLocalPartner);
    q('[data-fw-partner-reset]').addEventListener('click', resetPartnerForm);

    function syncAuth(){
      return sb.auth.getSession().then(function(r){
        session = r.data ? r.data.session : null;
        var signed = !!session;
        q('[data-fw-sign-out]').hidden = !signed;
        q('[data-fw-account-title]').textContent = signed ? 'You are signed in' : 'Sign in';
        q('[data-fw-auth-note]').textContent = signed ? 'You are ready to create.' : 'Sign in under Account before submitting a design.';
        if(signed) msg(q('[data-fw-account-result]'), session.user.email || 'Signed in', true);
        return checkAdmin();
      });
    }

    q('[data-fw-sign-in]').addEventListener('click', function(){
      sb.auth.signInWithPassword({
        email: (q('[data-fw-email]').value || '').trim(),
        password: q('[data-fw-password]').value || ''
      }).then(function(r){
        if(r.error) return msg(q('[data-fw-account-result]'), r.error.message, false);
        syncAuth();
      });
    });

    q('[data-fw-sign-up]').addEventListener('click', function(){
      var email = (q('[data-fw-email]').value || '').trim();
      sb.auth.signUp({
        email: email,
        password: q('[data-fw-password]').value || ''
      }).then(function(r){
        if(r.error) return msg(q('[data-fw-account-result]'), r.error.message, false);
        if(r.data && r.data.user){
          sb.from('fw_creators').upsert({ user_id: r.data.user.id, display_name: email.split('@')[0] }, { onConflict:'user_id' });
        }
        msg(q('[data-fw-account-result]'), r.data && r.data.session ? 'Account created and signed in.' : 'Account created, but Supabase email confirmation is still enabled.', !!(r.data && r.data.session));
        syncAuth();
      });
    });

    q('[data-fw-sign-out]').addEventListener('click', function(){
      sb.auth.signOut().then(syncAuth);
    });

    q('[data-fw-submit-design]').addEventListener('click', async function(){
      var resultEl = q('[data-fw-create-result]');
      var submitBtn = q('[data-fw-submit-design]');
      try {
        if(!session) throw new Error('Sign in first.');
        if(!selectedAthlete || !selectedAthlete.fanworks_athlete_id) throw new Error('Choose an enabled athlete first.');

        var title = (q('[data-fw-title]').value || '').trim();
        var artworkFile = q('[data-fw-artwork-file]').files[0];
        var mockupFile = q('[data-fw-mockup-file]').files[0];

        if(!title) throw new Error('Add a design title.');
        if(!artworkReady) throw new Error('Choose a valid transparent 3300 × 4200 PNG first.');
        if(!mockupReady) throw new Error('Choose a valid shirt mockup first.');
        submitBtn.disabled = true;

        msg(resultEl, 'Checking artwork requirements...', false);
        await validateArtworkFile(artworkFile);
        await validateMockupFile(mockupFile);

        msg(resultEl, 'Creating your FanWorks creator profile...', false);
        var creatorId = await ensureCreatorId();

        msg(resultEl, 'Uploading print-ready artwork...', false);
        var artworkUrl = await uploadDesignFile(artworkFile, 'artwork');

        msg(resultEl, 'Uploading shirt mockup...', false);
        var mockupUrl = await uploadDesignFile(mockupFile, 'mockup');

        msg(resultEl, 'Submitting design for approval...', false);
        var insertRes = await sb.from('fw_designs').insert({
          creator_id: creatorId,
          athlete_id: selectedAthlete.fanworks_athlete_id,
          title: title,
          artwork_url: artworkUrl,
          print_front_url: artworkUrl,
          mockup_url: mockupUrl,
          status: 'submitted'
        });
        if(insertRes.error) throw insertRes.error;

        q('[data-fw-title]').value = '';
        resetUploads();
        msg(resultEl, 'Submitted to ' + selectedAthlete.display_name + ' for approval. Once approved, FanWorks can route production to a local partner serving this school.', true);
      } catch(err){
        msg(resultEl, (err && err.message) ? err.message : 'Could not submit design.', false);
      } finally {
        updateSubmitReady();
      }
    });

    function loadMarket(){
      var grid = q('[data-fw-market]');
      grid.innerHTML = '<div class="fw-empty">Loading live FanWorks...</div>';
      sb.from('fw_products')
        .select('id,retail_cents,sku,design:fw_designs(title,mockup_url,athlete:fw_athletes(display_name,school_name))')
        .eq('active', true)
        .limit(24)
        .then(function(r){
          if(r.error){
            grid.innerHTML = '<div class="fw-empty">Unable to load products.</div>';
            return;
          }
          var d = r.data || [];
          if(!d.length){
            grid.innerHTML = marketEmptyMarkup;
            return;
          }
          grid.innerHTML = d.map(function(p){
            var x = p.design || {};
            var a = x.athlete || {};
            return '<article class="fw-product">'+
              '<img loading="lazy" src="'+esc(x.mockup_url || '')+'" alt="">'+
              '<h3>'+esc(x.title || 'FanWork')+'</h3>'+
              '<p>'+esc(a.display_name || '')+' · '+esc(a.school_name || '')+'</p>'+
              '<strong>$'+((p.retail_cents || 0) / 100).toFixed(2)+'</strong>'+
            '</article>';
          }).join('');
        });
    }

    function loadJobs(){
      var holder = q('[data-fw-jobs]');
      if(!session){
        holder.innerHTML = '';
        return;
      }
      holder.innerHTML = '<div class="fw-empty">Loading production jobs...</div>';
      fetch(url + '/functions/v1/fanworks-printer-jobs', {
        headers: {
          Authorization: 'Bearer ' + session.access_token,
          apikey: key
        }
      })
      .then(function(r){
        return r.json().catch(function(){ return {}; }).then(function(o){ return { r:r, o:o }; });
      })
      .then(function(x){
        if(!x.r.ok){
          holder.innerHTML = '<div class="fw-empty">Could not load jobs.</div>';
          return;
        }
        var jobs = x.o.jobs || [];
        q('[data-fw-printer-status]').textContent = jobs.length ? 'Everything you need to print is below.' : 'No open jobs.';
        holder.innerHTML = jobs.length ? jobs.map(function(j){
          var actions = '';
          if(j.status === 'offered') actions = '<button data-id="'+esc(j.assignment_id)+'" data-action="accept">Accept job</button><button data-id="'+esc(j.assignment_id)+'" data-action="decline">Can\'t take it</button>';
          if(j.status === 'accepted') actions = '<button data-id="'+esc(j.assignment_id)+'" data-action="start">Start printing</button>';
          if(j.status === 'in_production') actions = '<button data-id="'+esc(j.assignment_id)+'" data-action="ready">Mark ready</button>';
          if(j.status === 'ready') actions = '<button data-id="'+esc(j.assignment_id)+'" data-action="complete">Complete job</button>';
          return '<article class="fw-job">'+
            '<div class="fw-job-head"><span class="fw-badge">'+esc(j.status)+'</span><span class="fw-badge">'+esc(j.route_type)+'</span></div>'+
            '<div class="fw-job-main">'+(j.mockup_url ? '<img class="fw-job-img" src="'+esc(j.mockup_url)+'" alt="">' : '')+
              '<div><h3>'+esc(j.product_title || j.design_title || 'FanWorks order')+'</h3><div class="fw-job-meta">'+esc(j.school_name || '')+' · '+esc(j.athlete_name || '')+'<br>Order '+esc(j.order_number || '')+' · Qty '+esc(j.quantity || 0)+'</div></div>'+
            '</div>'+
            '<div class="fw-job-actions">'+actions+'</div>'+
          '</article>';
        }).join('') : '<div class="fw-empty">No open jobs.</div>';
        holder.querySelectorAll('[data-action]').forEach(function(b){
          b.addEventListener('click', function(){ printerAction(b.dataset.id, b.dataset.action); });
        });
      });
    }

    function printerAction(id, action){
      fetch(url + '/functions/v1/fanworks-printer-action', {
        method: 'POST',
        headers: {
          'Content-Type':'application/json',
          Authorization: 'Bearer ' + session.access_token,
          apikey: key
        },
        body: JSON.stringify({ assignment_id: id, action: action })
      }).then(function(){ loadJobs(); });
    }

    q('[data-fw-load-jobs]').addEventListener('click', loadJobs);
    q('[data-fw-refresh]').addEventListener('click', loadMarket);
    sb.auth.onAuthStateChange(function(_e, s){
      session = s;
      syncAuth();
    });

    syncHomeLinks();
    loadCreatorSchools();
    loadMarket();
    syncAuth();
  }
})();
